// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"569":"fed7e873","1647":"4d4500d3","2589":"d6fdf0fb","7790":"2de7c709","8878":"d748c323"}[chunkId] + ".css";
};